export default __webpack_public_path__ + "static/media/xmines_nathanyell_sleepy.a716ada2.mp3";